import { render } from "./Message.vue?vue&type=template&id=25a5aa3e"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=25a5aa3e&lang=scss"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__